import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Säästä {{percentageAmount}}% valituista tuotteista',
    description:
      'Säästä {{percentageAmount}}% tilauksestasi, kun tilaat valittuja tuotteita. Tarjous on voimassa{{fromTo}} kunnes kampanjan enimmäisraja täyttyy, kumpi tahansa tulee ensin. Ei yhdistettävissä muihin kampanjoihin.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% alennus alkaen {{minSpendValue}}',
    description:
      'Säästä {{percentageAmount}}% tilauksestasi. Tarjous on voimassa{{fromTo}} kunnes kampanjan enimmäisraja täyttyy, kumpi tahansa tulee ensin. Ei yhdistettävissä muihin kampanjoihin.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Säästä {{amount}} valituista tuotteista',
    description:
      'Säästä {{amount}}, kun tilaat valittuja tuotteita. Tarjous on voimassa{{fromTo}} kunnes kampanjan enimmäisraja täyttyy, kumpi tahansa tulee ensin. Ei yhdistettävissä muihin kampanjoihin.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Säästä {{amount}} alkaen {{minSpendValue}}',
    description:
      'Säästä {{amount}} tietyllä tilauksen arvolla. Tarjous on voimassa{{fromTo}} kunnes kampanjan enimmäisraja täyttyy, kumpi tahansa tulee ensin. Ei yhdistettävissä muihin kampanjoihin.',
  },
  [OfferKindEnum.Bogo]: {
    title: 'Osta 2, maksa 1!',
    description:
      'Osta yksi tuote ja saat toisen ilmaiseksi. Tarjous on voimassa{{fromTo}} kunnes kampanjan raja täyttyy, kumpi tahansa tulee ensin. Ei yhdistettävissä muihin kampanjoihin.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Osta yksi, saat toisen puoleen hintaan!',
    description:
      'Osta yksi tuote ja saat toisen puoleen hintaan. Tarjous on voimassa{{fromTo}} kunnes kampanjan raja täyttyy, kumpi tahansa tulee ensin. Ei yhdistettävissä muihin kampanjoihin.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Ilmainen tuote tietyllä tilauksen arvolla',
    description:
      'Saat ilmaisen tuotteen, kun täytät tarjouksen ehdot. Tarjous on voimassa{{fromTo}} kunnes kampanjan raja täyttyy, kumpi tahansa tulee ensin. Ei yhdistettävissä muihin kampanjoihin.',
    reward_items_description: 'Valitse ilmainen tuotteesi.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Ilmainen tuote tilauksesi mukana',
    description:
      'Saat ilmaisen tuotteen, kun täytät tarjouksen ehdot. Tarjous on voimassa{{fromTo}} kunnes kampanjan raja täyttyy, kumpi tahansa tulee ensin. Ei yhdistettävissä muihin kampanjoihin.',
    qualifying_items_description: 'Valitse tuotteet, jotka asiakkaan on tilattava saadakseen ilmaisen tuotteen.',
    reward_items_description: 'Valitse ilmainen tuotteesi.',
  },
};

export default {
  offers,
  from_to: ' ajalla {{startsAt}}–{{endsAt}} tai',
  qualifying_items_title: 'Vaaditut tuotteet',
  reward_items_title: 'Ilmaiset tuotteet',
  buttons: {
    add: 'Lisää ostoskoriin',
  },
};
